// slider z produktami kupionymi przez innych

import React, { FC, useMemo } from 'react';
import { Trans } from 'react-i18next';
import { ButtonBack, ButtonNext, CarouselProvider, Slide, Slider } from 'pure-react-carousel';
import classnames from 'classnames';
import { ChevronLeft, ChevronRight } from 'react-bootstrap-icons';

import { useRWD } from 'hooks';
import { useGetProductsBoughtByOthers, useGetProductsBoughtByOthersMutation } from 'api';
import { Loader, Link } from 'components/controls';

import styles from 'theme/pages/Product/components/OthersAlsoBought/OthersAlsoBought.module.scss';

// typ danych wejściowych
interface IProps {
  productId: number;
}

const OthersAlsoBought: FC<IProps> = ({ productId }) => {
  const { isMobile } = useRWD();

  // pobranie listy produktów oglądanych prze3z innnych
  const { data: productsBoughtByOthersSimpleData, isLoading: isProductsBoughtByOthersLoading } =
    useGetProductsBoughtByOthers(
      productId,
      {
        page: 1,
        limit: 999
      },
      {
        onSuccess: (data) => {
          refetchProductsFullData({
            scopes: 'PriceProductData',
            productIds: data.items
              .map((item) => item.id)
              .toString()
              .replaceAll(',', '|'),
            page: 1,
            limit: 999
          });
        }
      }
    );

  // Pobranie listy produktów
  const { data: productsBoughtByOthersFullData, mutate: refetchProductsFullData } =
    useGetProductsBoughtByOthersMutation(productId);

  const homeLastViewedData = useMemo(() => {
    return productsBoughtByOthersSimpleData?.items?.map((simpleProduct) => {
      return productsBoughtByOthersFullData
        ? {
            ...simpleProduct,
            ...productsBoughtByOthersFullData?.items.find(
              (fullProduct) => fullProduct.id === simpleProduct.id
            )
          }
        : simpleProduct;
    });
  }, [productsBoughtByOthersSimpleData, productsBoughtByOthersFullData]);

  const renderItems = () => {
    return homeLastViewedData?.map((product, index) => {
      const price = product.product_price_short_info?.prices?.find(
        (price) => price.unit_id === product.product_unit_short_info?.default_unit_id || 0
      );

      return (
        <Slide key={product.id} index={index} className={styles.slide}>
          <div className={styles.productWrapper}>
            <Link to={`/${product.product_basic_short_info?.url_link}`} className={styles.product}>
              <div
                className={styles['product-image']}
                style={{
                  backgroundImage: `url(${product.product_image_formatted_short_info?.images?.[0]?.min})`
                }}
              />
              <div className={styles.description}>
                {product.product_basic_short_info?.title}
                <div className={styles.prices}>
                  <div className={styles.net}>
                    <strong>{price?.price_net_formatted}</strong> netto
                  </div>
                  <div className={styles.gross}>{price?.price_net_formatted} brutto</div>
                </div>
              </div>
            </Link>
          </div>
        </Slide>
      );
    });
  };

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Page-Product-components-OthersAlsoBought'
      )}>
      {!!productsBoughtByOthersSimpleData?.items.length && (
        <div className={styles.title}>
          <Trans>Inni kupili także</Trans>
        </div>
      )}

      {isProductsBoughtByOthersLoading && <Loader />}

      {!!productsBoughtByOthersSimpleData?.items.length && (
        <CarouselProvider
          naturalSlideWidth={0}
          naturalSlideHeight={0}
          totalSlides={productsBoughtByOthersSimpleData?.items.length || 0}
          visibleSlides={isMobile ? 1 : 4}
          className={styles.slider}>
          <ButtonBack disabled={isMobile} className={classnames(styles.navButton, styles.back)}>
            <ChevronLeft />
          </ButtonBack>
          <ButtonNext disabled={isMobile} className={classnames(styles.navButton, styles.next)}>
            <ChevronRight />
          </ButtonNext>
          <Slider>{renderItems()}</Slider>
        </CarouselProvider>
      )}
    </div>
  );
};

export default OthersAlsoBought;
